<template>
  <div class="unit-items">
    <div class="unit-title">
      <h3 class="font-weight-regular mb-0 white--text">{{ title }}</h3>
      <v-btn @click="add" class="ma-1 white" fab small light>
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>

    <draggable
      class="inner mt-5"
      :list="items"
      group="order"
      @start="startDrag()"
      @end="endDrag()"
      :ref="name"
      :id="name"
    >
      <div
        v-for="(item, index) in items"
        :key="`unit-${index}`"
        class="item mb-5 pa-4"
        :data-id="`${Math.round(new Date().getTime() / 1000)}`"
      >
        <div class="d-flex flex-row justify-space-between align-start">
          <div>
            <h2 class="break-spaces mb-2 mt-2">
              <v-chip :class="item.color">{{ item.title }}</v-chip>
            </h2>
          </div>
          <div class="icons pa-1" v-if="addItem">
            <v-icon @click="edit(index)" class="black--text">mdi-pencil</v-icon>
            <v-icon @click="remove(index)" class="black--text"
              >mdi-delete-forever</v-icon
            >
          </div>
        </div>

        <v-row>
          <v-col cols="2">
            <div v-if="item.options && item.options.length">
              <v-chip
                v-for="(attr, index) in item.options"
                :key="`options-${index}`"
                class="ma-half mr-1 mb-1"
                small
                >{{ attr }}</v-chip
              >
            </div>
          </v-col>
          <v-col cols="4">
            <p v-if="item.description" class="break-spaces ml-2">
              {{ item.description }}
            </p>
          </v-col>
          <v-col cols="6">
            <p class="body-2"><strong>Supporting points</strong></p>
            <ul class="no-bullets">
              <li v-for="(sub, count) in item.items" :key="`${index}-${count}`">
                {{ sub }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </div>
    </draggable>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else-if="editMode">
        <embed-form
          v-model="item"
          title="Edit an item"
          :content="content"
          :showColors="true"
          :key="item.index"
        >
          <v-btn light color="green" class="mt-10 mr-2" @click="editItem"
            >Update</v-btn
          >
          <v-btn light color="white" class="mt-10 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </embed-form>
      </v-card>
      <v-card light v-else>
        <embed-form
          v-model="item"
          title="Add an item"
          :content="content"
          :showColors="true"
          :key="item.index"
        >
          <v-btn light color="green" class="mt-10 mt-2 mr-2" @click="addItem"
            >Create Attribute</v-btn
          >
          <v-btn light color="white" class="mt-10 mt-2 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </embed-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
import EmbedForm from "@/views/user/exercises/attributes/EmbedForm";
var defaults = {
  title: "Default",
  description: "",
  items: [],
};
export default {
  name: "QuadrantItems",
  data() {
    return {
      items: this.value,
      item: { title: "", description: "", items: [] },
      currIndex: null,
      refs: null,
      fields: [],
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
      counter: 0,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    content: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    draggable,
    EmbedForm,
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      this.item = defaults;
      this.editMode = false;
      this.dialog = true;
      console.log("Add");
      this.resetItem();
    },
    addItem() {
      let item = {
        index: this.items.length,
        ...this.item,
        id: this.items.length,
        type: "content",
      };
      this.items.push(item);

      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
      this.counter++;
      this.resetItem();
      this.$emit("handleEnd");
    },
    remove(index) {
      this.deleteMode = true;
      this.deleteId = index;
      this.dialog = true;
    },
    removeItem() {
      this.items.splice(this.deleteId, 1);
      this.cancel();
    },
    edit(index) {
      this.editMode = true;
      this.dialog = true;
      this.editIndex = index;
      this.item = this.items[this.editIndex];
    },
    editItem() {
      let item = {
        index: this.editIndex,
        ...this.item,
        id: this.editIndex,
        type: "content",
      };
      this.$set(this.items, this.editIndex, item);
      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
      this.counter++;
      this.resetItem();
      this.$emit("handleEnd");
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.deleteMode = false;
      this.counter++;
    },
    resetItem() {
      this.item = {};
      this.$set(this.item, "items", []);
    },
    checkEditIndex(index) {
      if (this.editMode) {
        return index == this.editIndex ? false : true;
      } else {
        return false;
      }
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.items.indexOf(item);
          item.index = count;
          vm.$set(vm.items, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  .item {
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    padding: 0.5rem;
    margin: 0.5rem 0;
    background: white;
    border-radius: 5px;
    color: black;
    .icons {
      width: 50px;
      padding: 0 10px 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
.no-bullets {
  list-style: none;
  margin: 0;
  padding: 0 0 0px 0px;
  li {
    padding: 3px 0;
    border-bottom: dotted 1px #333;
  }
}
</style>
